export default {
    locale: 'es',
    messages: {
        actions: 'Acciones',
        add: 'Añadir',
        addressAddNew: 'Añadir una nueva dirección',
        addressChangeAddress: 'Elige otra dirección',
        addressCity: 'Ciudad',
        addressCountry: 'País',
        addressDeleteConfirmMessage: '¿Seguro que quiere borar esta dirección?',
        addressDeleteConfirmTitle: 'Supresión de una dirección',
        addressDeleteSuccess: '¡Se ha borrado la dirección! ',
        addressEdit: 'Editar dirección',
        addressesMyManage: 'Administrar mis direcciones',
        addressInvoice: 'Dirección de facturación',
        addressInvoiceCountry: 'País de facturación',
        addressInvoiceSameAsShippingLabel: '¿Los datos de facturación son idénticos a los datos de entrega?',
        addressInvoiceUsedFor: 'Definido como dirección de facturación',
        addressInvoiceUsedForSuccess: 'Dirección de facturación actualizada!',
        addressLabel: 'Etiquetada Dirección',
        addressMy: 'Mis direcciones',
        addressMyViewButton: 'Ver mis direcciones',
        addressName: 'Destinatario',
        addressNameAlt: 'Nombre de la empresa (si se entrega en el trabajo)',
        addressNoItems: '¡Aún no ha registrado su dirección!',
        addressPhone: 'Teléfono (útil para entrega)',
        addressPostalCode: 'Código postal',
        addressRegion: 'Provincia',
        addressSavedCountryError: '¡Este país no está permitido!',
        addressSavedSuccess: '¡Su dirección está registrada!',
        addressSelectOptions: 'Elige una direccion',
        addressShipping: 'Dirección de entrega',
        addressShippingCountry: 'País de entrega',
        addressStreet1: 'Dirección',
        addressStreet2: 'Piso, código de puerta, interfono, ...',
        administrationTitle: 'Administración',
        alertFetchApiError: 'El servidor está actualmente fuera de servicio...',
        alertFormRequiredFieldsError: '¡Por favor, rellene todos los campos obligatorios!',
        alertGenericError: '¡Se produce un error! Pruebe más tarde...',
        alertJsonParseError: 'El servidor devolvió una respuesta equivocada...',
        alertUnauthorized: '¡Su sesión ha expirado! Por favor, vuelva a conectar',
        alertContactError: '¡No se puede enviar el mensaje! Inténtelo de nuevo...',
        alertContactSuccess: '¡Ha sido recibido con éxito!',
        alertUserAlreadyExists: '¡Ya existe una cuenta con esta dirección de correo electrónico!',
        alertUserRegisterSuccess: '¡Bienvenido! Por favor, inicie sesión con su contraseña temporal recibida en su correo electrónico {user}',
        app404ErrorTitle: 'El camino equivocado...',
        appAccessButton: 'Acceder a {app}',
        appConditionsAcceptTitle: 'Condiciones generales de uso',
        appConditionsCheckError: '¡Por favor marque haber leído las condiciones generales de uso!',
        appConditionsCheckLabel: 'He leído y acepto las condiciones generales de uso',
        appConditionsCheckSuccess: '¡Ha sido recibido con éxito!',
        appConditionsUpdateDate: 'Actualización el {fecha}',
        appCookieConsentText: 'Al navegar por este sitio web, Usted acepta el uso de cookies para el buen funcionamiento del servicio propuesto y las estadísticas. No podrán publicarse datos personales sin su consentimiento.',
        appCookieConsentPrivacyLink: 'Consulta nuestra política de privacidad',
        appForceUpdateApp: 'Forzar la actualización de la aplicación',
        appAdvantagesFabrication: 'Fabricado en Europa',
        appAdvantagesFreeShipping: 'Envío gratuito en Europa',
        appAdvantagesInternationalShipping: 'Entrega internacional',
        appAdvantagesSecurePayment: 'Pago seguro',
        appVersionCurrent: 'Versión actual de la aplicación: {versión}',
        back: 'Volver',
        by: 'por',
        cancel: 'Cancelar',
        cartAddToButton: 'Añadir al carrito',
        cartBackToHomeButton: 'Continuar con el sitio',
        cartConfirmationText: 'Recibirá un correo electrónico de confirmación, <br />Su pedido será visible y podrá seguirlo vía <a href="{link}">tu cuenta</a>.',
        cartConfirmationTitle: '¡Gracias! <br />Su pedido <a href="{link}" class="text-warning text-underline">{orderNumber}</a> está validado.',
        cartConfirmationSubText: 'Ven a charlar en las redes sociales',
        cartDeliveryTitle: 'Entrega',
        cartEmptyError: 'Su carrito está vacía...',
        cartInvoiceAddressSelectionTitle: 'Seleccione su dirección de facturación',
        cartItemProductPackPriceAlertTitle: 'Precios decrecientes',
        cartItemProductPackPriceAlertText: 'Aumenta el número de botes para disfrutar de tarifas ventajosas',
        cartLegalMentionText: 'Al validar su pedido usted reconoce haber leído las Condiciones generales de venta y usted acepta los términos.',
        cartNextButton: 'Siguiente',
        cartNotValidError: '¡Por favor, compruebe su carrito antes de continuar!',
        cartPayButton: 'Realizar el pago',
        cartPaymentBankTransferLabel: 'Pago por transferencia bancaria',
        cartPaymentCreditCardLabel: 'Pago con tarjeta de crédito',
        cartPaymentPaypalLabel: 'Pago con Paypal',
        cartPendinpPaymentText: 'Sólo estamos esperando su pago para procesar su pedido...',
        cartStepPaymentTitle: 'Su pago',
        cartStepPaymentInfoText: '¡Bravo, ya casi llegamos! <br />Introduzca su método de pago.',
        cartStepPreviewTitle: 'Su carrito',
        cartStepPreviewInfoText: 'Aquí está en su carrito.<br />Piense en nuestras tarifas decrecientes.',
        cartStepShippingTitle: 'Sus datos de contacto',
        cartStepShippingInfoText: 'Compruebe su dirección de entrega <br />y todos los detalles necesarios para el transportista.',
        cartShippingAddressMissingError: '¡No has introducido tu dirección de entrega!',
        cartShippingAddressSelectionTitle: 'Seleccione su dirección de entrega',
        cartShippingCalculatedTitle: 'Entrega e IVA',
        cartShippingCalculationText: 'Introduzca su país de entrega',
        cartShippingCalculationTitle: 'Calcule sus gastos de envío e IVA.',
        cartShippingCalculationListButton: 'País de entrega',
        cartShippingSetAlert: 'Quiere que le entreguen en {country}',
        cartShippingUnavailableAlert: 'No podemos entregar en su área',
        cartShippingUnavailableLink: 'Ver la lista de países',
        cartShippingValidateDetails: 'Confirmar los detalles de la entrega',
        cartTotalNotSet: 'No se aplica.',
        cartTotalShipping: 'Envío',
        cartTotalShippingFree: 'Gratis.',
        cartTotalSubTotal: 'Subtotal',
        cartTotalTax: 'IVA',
        cartTotalTotal: 'Total',
        cartVoucherApplyTitle: 'Código de promoción',
        checkToggler: 'Seleccionar/Deseleccionar todo',
        choose: 'Elija',
        close: 'Cerrar',
        cms: 'CMS',
        cmsContentEdit: 'Edición de contenidos',
        cmsContentIsActive: '¿Contenido activado?',
        cmsContentModelLabel: 'Modelo',
        cmsContentSlug: 'Camino de acceso',
        cmsContentTitle: 'Título',
        cmsContentTranslations: 'Traducciones',
        cmsContentTypeLabel: 'Tipo de contenido',
        cmsPageSeoDescription: 'Descripción SEO',
        cmsPageSeoKeywords: 'Palabras clave de SEO',
        cmsPageSeoTitle: 'Título SEO',
        cmsPanelIsTemplate: 'Incluido en el tema',
        configuration: 'Configuración',
        contactByEmail: 'Por correo electrónico',
        contactInfoText: 'Para cualquier pregunta sobre nuestro producto o su pedido',
        contactNeedHelpTitle: '¿Necesita ayuda?',
        contactPageButton: 'Envía',
        contactPageTitle: 'Contáctanos.',
        contactPageText1: '¿Necesita ayuda? ¿Necesita información? Estamos aquí para ayudarle!',
        contactTitle: 'Contacto',
        contactUsByPhone: 'Contáctenos en',
        continue: 'Continúa...',
        country: 'País',
        countryFillPlaceholder: '"Introduzca un país y luego pulse Enter """""',
        countrySelectPlaceholder: 'Seleccione un país',
        dateActivated: 'Fecha de activación',
        dateCreated: 'Fecha de creación',
        dateCreation: 'Fecha de creación',
        dateLastCguAccept: 'Fecha de la última validación del TOS',
        dateLastEdit: 'Fecha de la última modificación',
        dateLastLogin: 'Fecha de la última conexión',
        dateLastOrder: 'Fecha del último pedido',
        dateSelect: 'Seleccione una fecha',
        dateSelectPlaceholder: 'Haga clic aquí para seleccionar una fecha...',
        dashboardTitle: 'Salpicadero',
        date: 'Fecha',
        dateThe: 'en {date}',
        days: 'Día(s)',
        delete: 'Cancelar',
        deleteRequestError: '¡Error de borrado!',
        deleteRequestSuccess: '¡Borrado!',
        domain: 'Dominio',
        download: 'Descargar',
        edit: 'Edita',
        editViewAdvanced: 'Edición avanzada',
        editViewSimplified: 'Edición simplificada',
        elementNoItems: 'No hay artículos',
        example: 'Ejemplo',
        examples: 'Ejemplos',
        file: 'Archivo',
        fileDeleteError: 'No se puede borrar este archivo',
        fileDeleteSuccess: '¡Fichero eliminado!',
        files: 'Archivos',
        fileUploadError: '¡No se puede cargar este archivo!',
        fileUploadProcessStartOnSave: 'La carga del archivo comenzará cuando se guarde.',
        fileUploadSuccess: '¡Fichero subido!',
        fileUploadRestrictionTypeError: '¡Formato de archivo no aceptado! Permitido: {type}',
        filtersTitle: 'Filtros',
        finish: 'Finalizar',
        formFieldRequired: '¡Campo requerido!',
        formFieldValidEmail: 'Por favor, introduzca una dirección de correo electrónico válida!',
        generalInformation: 'Información general',
        help: 'Ayuda',
        hours: 'Horario',
        imageDeleteError: '¡No se puede borrar esta imagen!',
        imageDeleteSuccess: '¡Imagen eliminada!',
        imageUploadError: 'No se puede cargar esta imagen',
        imageUploadRestrictionSize: 'La imagen debe tener un tamaño máximo de {format}.',
        imageUploadRestrictionType: 'La imagen debe estar en {type}.',
        imageUploadRestrictionTypeError: '¡Formato de imagen no aceptado! Permitido: {type}',
        import: 'Importación',
        importerFileInfo: 'Seleccione un archivo CSV (Valores separados por comas)',
        importerFileHelp: 'Puede generar un archivo CSV usando su software de hoja de cálculo (Excel, OpenOffice, ...)',
        importerNoItemsAlert: 'Ningún elemento a importar',
        importerTitle: 'Importación de datos',
        importerFileButton: 'Importar datos',
        importModelDownloadButton: 'Descargue la maqueta',
        importRequestError: '¡Se produjo un error durante la importación!',
        importRequestSomeFailAlert: '¡Una o más entradas no podían ser importadas!',
        importRequestSuccess: '¡Datos importados!',
        information: 'Información',
        informationsDetails: 'Detalles',
        informationsGeneral: 'Información general',
        isActive: '¿Activo?',
        isPublic: '¿Público?',
        isUnlimited: '¿Ilimitado?',
        label: 'Titulado',
        langDE: 'Deutsh',
        langEN: 'English',
        langES: 'Español',
        langFR: 'Français',
        language: 'Idioma',
        learnMore: 'Para saber más sobre ello',
        listTitle: 'Lista',
        loading: 'Cargando...',
        loadMore: 'Cargar más...',
        logo: 'Logotipo',
        matter: 'Asunto',
        minutes: 'Minuto(s)',
        name: 'Nombre',
        next: 'Siguiente',
        newsletterInfoText: '¿Quiere saber más? Inscríbete a nuestro boletín informativo',
        newsletterTitle: 'Boletín de noticias',
        no: 'No',
        options: 'Opciones',
        orderAdd: 'Añadir un pedido',
        orderBuyButton: 'Compra',
        orderCartLink: 'Carrito',
        orderCreationError: 'No podemos crear su pedido en este momento... ¡Gracias por contactarnos!',
        orderCreationProcessing: 'Creamos su pedido...',
        orderFlags: 'Banderas',
        orderInformationDetails: 'Detailles del envio',
        orderInvoice: 'Factura',
        orderInvoiceDate: 'Fecha de facturación',
        orderInvoiceNumber: 'Número de factura',
        orderItems: 'Contenido',
        orderMy: 'Mi pedido',
        ordersMyViewButton: 'Ver mis pedidos',
        ordersMy: 'Mis pedidos',
        orderNoElements: '¡Aún no ha pedido!',
        orderPaymentFinishTitle: 'Continuar con mi pago',
        orderPaymentMethod: 'Forma de pago',
        orderPaymentMethodBanktransfer: 'Transferencia bancaria',
        orderPaymentMethodCreditcard: 'Tarjeta de pago',
        orderPaymentMethodPaypal: 'Paypal',
        orderPaymentProcessButton: 'Haga el pago',
        orderPaymentProcessing: 'Recopilamos datos para su pago...',
        orderPayments: 'Pagos',
        orderPaymentStatusPending: 'Esperando',
        orderPaymentStatusComplete: 'Terminado',
        orderPaymentUnavailableAlert: 'El método de pago no está disponible... Por favor, póngase en contacto con nosotros para hacer su pago.',
        orderPaymentValidButton: 'Valido el pago',
        orderPaymentValidSuccess: 'Pago validado',
        orderProductAdd: 'Añadir un producto',
        orderReOrderButton: 'Redoblar mi pedido',
        orders: 'Pedidos',
        orderShippings: 'Expediciones',
        orderStatusArchived: 'Archivado',
        orderStatusCanceled: 'Cancelado',
        orderStatusComplete: 'Terminado',
        orderStatusOnpreparation: 'En preparación',
        orderStatusPendingpayment: 'A la espera del pago',
        orderStatusShipped: 'Enviado ',
        orderSubscribeButton: 'Suscribir',
        orderTotal: 'Total',
        orderWeight: 'Peso del pedido',
        Page404ErrorTitle: 'No hemos encontrado lo que está buscando...',
        priceHT: 'Precio sin IVA',
        priceTTC: 'Precio con IVA incluido',
        previous: 'Anterior',
        productAdd: 'Añadir un producto',
        productAddedSuccess: '¡Se ha añadido!',
        productCodeEAN: 'Código EAN',
        productComposition: 'Composición',
        productDescription: 'Descripción',
        productDuplicateSuccess: '¡Duplicar el producto!',
        productEdit: 'Modificar el producto',
        productImageSaveBeforeAlert: '¡Debe registrar este producto antes de añadir una imagen!',
        productName: 'Nombre',
        productPackChoiceTitle: 'Descubra nuestros packs',
        productPackFreeCount: `+{count} {count, plural,
            =0 {bote}
            =1 {bote}
            other {botes}
        } GRATIS`,
        productPackMonthlyConsumptionLabel: 'Recomendado para 1 mes',
        productPackUnitPrice: 'O {price}/bote',
        productPriceInformation: 'Tarifas',
        products: 'Productos',
        productSelectOptions: 'Seleccione un producto',
        productSlug: 'Camino',
        productSubTotal: 'Precio con IVA incluido',
        productTaxCalculate: 'Calcule',
        productTaxRate: 'Tasa de impuesto',
        productTaxRateTaxCalculation: 'O {tax} IVA',
        productUnitLabel: 'bote',
        productUnitCountLabel: `{count} {count, plural,
            =0 {bote}
            =1 {bote}
            other {botes}
        }`,
        quantity: 'Cantidad',
        refresh: 'Actualizar',
        remove: 'Eliminar',
        retry: 'Reinicie',
        reviewAddFirstReviewButton: 'Presentar mi opinión',
        reviewAddFirstReviewText: '¿Le gusta nuestro producto? ¿Le gustaría compartir su opinión con nuestros clientes? Comparta su experiencia! ¡¡Sólo le llevará dos minutos!',
        reviewAddFirstReviewTitle: '¡Valora nuestro producto!',
        reviewAddLoading: 'Grabamos su opinión...',
        reviewAddSuccess: 'Hemos recibido sus comentarios! Se publicará después de la moderación...',
        reviewAnswer: 'Respuesta de Atremoplus',
        reviewFilterLabel: 'Ordenar los testimonios',
        reviewFilterLanguageLabel: 'Por el idioma',
        reviewLink: 'Copia el enlace de tu video',
        reviewLinkHelp: 'Guarde su video en Youtube (por ejemplo) y luego copie el enlace del video en el campo de arriba.',
        reviewLinkViewButton: 'Vea el enlace',
        reviewName: 'Nombre y pais',
        reviews: 'Aviso',
        reviewScoreLabel: 'Elija su nota...',
        reviewSummaryButton: 'Descubra sus testimonios',
        reviewSummaryTitle: 'Nuestros clientes hablan lo mejor de esto, ¡descubre sus opiniones!',
        reviewText: 'Ingrese su opinión ...',
        reviewTitle: 'El titulo de tu testimonio',
        reviewTypeLinkLabel: 'Medios de comunicación',
        reviewTypeTextLabel: 'Texto',
        save: 'Registrarse',
        saveBeforeAlert: 'Por favor, guarde primero...',
        saveRequestError: '¡Error de registro!',
        saveRequestSuccess: '¡Registrado!',
        saving: 'El registro...',
        searchFor: 'Busca en',
        seconds: 'Segundo(s)',
        selectAll: 'Seleccione todo.',
        selectUnAll: 'Deseleccionar todo',
        selectFile: 'Seleccione un archivo',
        selectImage: 'Seleccione una imagen',
        selectOptions: 'Seleccione una opción',
        seoTitle: 'Suplemento natural de L-Dopa',
        shippingFeeAmountLabel: 'Importe',
        shippingFeeCarrierLabel: 'Transportista',
        shippingFeeCountriesLabel: 'Países seleccionados',
        shippingFeeExcludeDepartmentInfo: '"Separa los códigos con una coma (,). Usa *"" como comodín."""',
        shippingFeeExcludeDepartmentLabel: 'Código postal para excluir',
        shippingFeeFreeThresholdInfo: 'Ponga este valor en 0 para desactivar el envío gratuito.',
        shippingFeeFreeThresholdLabel: 'Cantidad mínima que debe alcanzarse para aplicar la entrega ofrecida',
        shippingFeeHasExcludeConditions: 'Con excepciones',
        shippingFees: 'Los gastos de envío',
        shippingFeeTrackingUrlInfo: 'Puede añadir "{trackingNumber}" a la url para incluir el número de seguimiento automáticamente.',
        shippingFeeTrackingUrlLabel: 'URL de detección',
        status: 'Estado',
        stepTitle: 'Paso.',
        subscription: 'Suscripción',
        subscriptionCartButton: 'Suscribo sin compromiso',
        subscriptionCartText: 'Piensa en la suscripción: Elige su período, su pack, SIN compromiso y fácil de suscribir!',
        subscriptionResumeTitle: 'Su suscripción',
        subscriptionResumeText: `Ha elegido una suscripción de {count} {count, plural,
            =0 {bote}
            =1 {bote}
            other {botes}
        } cada {period}`,
        subscriptionConfigurationPackTitle: 'Elección del pack',
        subscriptionConfigurationPeriodTitle: 'Elige el intervalo de pago',
        subscriptionConfigurationTitle: 'Configura su suscripción',
        subscriptionCreateButton: 'Me suscribo sin compromiso',
        subscriptionPeriod1Month: '1 mes',
        subscriptionPeriod6Week: '6 semanas',
        subscriptionPeriod2Month: '2 meses',
        subscriptionRemoveButton: 'No deseo suscribirme en este momento.',
        subscriptionStopButton: 'Darse de baja del boletín',
        submit: 'Envíe',
        switch: 'Cambiar',
        switchLanguage: 'Cambiar el idioma',
        tableMassActions: 'Acciones agrupadas...',
        tableRefreshSuccessError: '¡Error de sincronización!',
        tableRefreshSuccessAlert: '¡Sincronizado!',
        tableSelection: `{count} {count, plural,
            =0 {seleccionado}
            =1 {seleccionado}
            otros {seleccionados}
        }`,
        tag: 'Palabra clave',
        tags: 'Palabras clave',
        tagFillPlaceholder: 'Introduce una palabra clave y pulsa intro...',
        taxes: 'Impuestos',
        taxCountriesLabel: 'Países seleccionados',
        taxHasCustomsFees: '¿Las tasas de aduana?',
        taxHasCustomsFeesInfo: 'Con las tasas de aduana',
        taxRate: 'IVA',
        taxRateLabel: 'Tasa de impuesto',
        taxThresholdLabel: 'Importe mínima para aplicar la tasa',
        time: 'Tiempo',
        timezone: 'Zona horaria',
        the: 'el',
        title: 'Título',
        total: 'Total',
        type: 'Tipo',
        unit: 'Unidad',
        user: 'Usuario',
        userAccountDataProtection: 'Protección de datos',
        userAccountDataProtectionText1: 'Nos tomamos muy en serio la protección de sus datos personales, por lo que nos comprometemos a mantenerlos seguros y a conservarlos durante un período razonable de tiempo necesario para el buen desarrollo de los exámenes.',
        userAccountDataProtectionText2: 'Sólo le pedimos la información necesaria para el servicio y nos comprometemos a no comunicar nunca a un servicio de terceros ni a utilizar sus datos personales con fines comerciales sin su consentimiento.',
        userAccountDataProtectionText3: 'Si desea recuperar sus datos o usar su derecho a la portabilidad de datos, por favor contáctenos en {email}.',
        userAccountDelete: 'Cancelar mi cuenta',
        userAccountDeleteBlockText: '¡No puede cancelar su cuenta en este momento!',
        userAccountDeleteButton: 'Cancelar mi cuenta',
        userAccountDeleteConfirmMessage: '¿Está seguro de que quiere cancelar su cuenta de forma permanente?',
        userAccountDeleteConfirmTitle: 'Cancelar mi cuenta',
        userAccountDeleteError: 'No se puede cancelar su cuenta!',
        userAccountDeleteSuccess: '¡Tu cuenta ha sido eliminada! ¡Hasta pronto!',
        userAccountDeleteText: 'Al borrar su cuenta, eliminará el acceso a su información en este sitio. Borraremos su información personal de nuestra base de datos. ¡Esta acción es irreversible!',
        userAccoutDetailsTitle: 'Sus datos',
        userAccountEdit: 'Modificar mi cuenta',
        userAccountEditSuccess: 'Cuenta actualizada',
        userAccountExistTitle: '¿Ya tiene una cuenta?',
        userAccountHistory: 'Historial',
        userAccountInfo: '¡Su información no se hará pública!',
        userAccountInfoMyTitle: 'Mi información',
        userAccountGeneral: 'General',
        userAccountMy: 'Mi cuenta',
        userAccountPersonnalInformation: 'Mi información personal',
        userAccountPreferencesInformation: 'Mis preferencias',
        userAccountResetError: '¡Error al reiniciar la cuenta!',
        userAccountResetSuccess: '¡Reinicio de la cuenta!',
        userActivityOnLine: 'En línea',
        userAdd: 'Añadir un usuario',
        userAddNew: 'Añadir un nuevo usuario',
        userChangePasswordSuccess: '¡Contraseña cambiada!',
        userConfirmationCode: 'Código de confirmación recibido por correo electrónico',
        userConfirmationCodeCheckButton: 'He recibido el código para restablecer mi contraseña.',
        userConfirmationCodeError: '¡Por favor, introduzca el código de confirmación! ¡Revisa su buzón de email!',
        userConnectionInfo: 'Accede a su cuenta para validar su pedido e invitar a sus amigos a participar!',
        userCustomerAccountLink: 'Cuenta de cliente',
        userCustomerNewSubTitle: 'Datos de contacto y cuenta de cliente',
        userCustomerNewTitle: '¿Nuevo cliente?',
        userCustomerRegisteredSubTitle: 'Inicia sesión',
        userCustomerRegisteredTitle: 'Ya es cliente',
        userDeleteConfirmation: 'ha sido borrado!',
        userEdit: 'Modificar {user}',
        userEdit2: 'Cambiar de usuario',
        userEditPassword: 'Cambiar mi contraseña',
        userEmail: 'Dirección de correo electrónico',
        userEmailError: '¡Su dirección de correo electrónico es incorrecta!',
        userEmailFillInfo: 'Introduzca su dirección de correo electrónico',
        userEmailFormInfo: 'Introduzca su correo electrónico para continuar',
        userEmailSwitch: 'Cambie su dirección de correo electrónico',
        userFillPlaceholder: 'Introduce un nombre de usuario...',
        userFirstName: 'Nombre ',
        userForgotPassword: '¿Olvidó su contraseña?',
        userForgotPasswordRetryDateError: 'No puede solicitar una contraseña de nuevo. Por favor, compruebe su buzón de correo electrónico para recuperar el código de confirmación.',
        userGroupsTitle: 'Grupos de usuarios',
        userGroupsFillPlaceholder: 'Introduce el nombre de un grupo...',
        userHistory: 'Seguimiento del usuario {user}',
        userIsActive: '¿Activo?',
        userLastName: 'Nombre',
        userLogin: 'Conexión',
        userLoginAction: 'Iniciar sesión',
        userLoginEmailSelected: 'Conexión con la dirección de correo electrónico: {email}',
        userLoginError: '¡Credenciales equivocadas! Por favor, inténtelo de nuevo...',
        userLoginFirstButton: '¿Primer acceso?',
        userLoginFirstText: 'Revisa su buzón de email para recuperar su contraseña temporal. Use esta contraseña para su primera conexión. Entonces podrá cambiar su contraseña.',
        userLoginIntro: 'Por favor, identifíquese para acceder a su espacio.',
        userLoginNoConnexion: 'No hay conexión',
        userLoginTitle: 'Conexión',
        userLogout: 'Cierre de sesión',
        userName: 'Nombre',
        userNewPassword: 'Nueva contraseña',
        userOldPassword: 'Contraseña antigua',
        userOptions: 'Opciones de usuario',
        userPassword: 'Contraseña',
        userPasswordConfirmation: 'Confirmación de la contraseña',
        userPasswordConfirmationError: 'Por favor, introduzca una confirmación idéntica a la contraseña!',
        userPasswordConfirmationRestriction: 'La confirmación debe ser idéntica a la contraseña introducida.',
        userPasswordDisplayButton: 'Ver la contraseña',
        userPasswordEdit: 'Cambiar mi contraseña',
        userPasswordError: 'Por favor, introduzca una contraseña correcta!',
        userPasswordHideButton: 'Ocultar la contraseña',
        userPasswordResetText: 'Por favor, introduzca su contraseña personal. Confirme y haga clic en el botón de abajo.',
        userPasswordRestriction: '¡La contraseña debe respetar 6 caracteres!',
        userPasswordRestrictionAlt: '¡La contraseña debe respetar 6 caracteres!',
        userPasswordTemporaryCheckButton: 'He recibido mi contraseña temporal.',
        userPhone: 'Teléfono',
        userProfileMy: 'Mi perfil',
        userRegister: 'Crear mi cuenta',
        userReInitPassword: 'Restablecer mi contraseña',
        userRegisterError: '¡No se puede crear una cuenta! Por favor, compruebe su dirección de correo electrónico e inténtelo de nuevo...',
        userRegisterSuccess: '¡Felicidades! ¡Su cuenta ha sido creada!',
        userResetPasswordAccountButton: 'Restablecer la contraseña de la cuenta',
        userResetPasswordError: '¡No se puede restablecer la contraseña! Por favor, inténtelo de nuevo más tarde...',
        userResetPasswordInfo: 'Recibirá un código en su buzón de email para restablecer su contraseña.',
        userResetPasswordInfo2: 'Reinicie su contraseña rellenando los campos de abajo:',
        userResetPasswordSuccess: '¡Contraseña restablecida con éxito!',
        userRole: 'Papel',
        userRoleCustomer: 'Cliente',
        userRoleAdmin: 'Administrador',
        users: 'Usuarios',
        userSearchLabel: 'Escriba un correo electrónico o un nombre de usuario',
        userSelectPlaceholder: 'Seleccione un usuario',
        userSendNewAccountEmail: 'Enviar un correo electrónico de la nueva cuenta al usuario',
        userSendNewAccountEmailSuccess: '¡El usuario está avisado!',
        usersList: 'Lista de usuarios',
        userSubscribeNewsletterLabel: 'Me gustaría recibir ofertas personalizadas de Atremoplus®.',
        userSwitch: 'Cambiar de usuario',
        userValidForgotPasswordError: '¡No se puede enviar el código de restablecimiento de la contraseña!',
        userValidForgotPasswordSuccess: 'Revisa su buzón de correo electrónico para usar su código de confirmación para restablecer su contraseña!',
        valid: 'Validar',
        view: 'Ver',
        voucher: 'Código de descuento',
        voucherCodePlaceholder: 'Introduzca su código de promoción',
        voucherNotExistsError: '¡Este código de cupón no existe!',
        voucherNotValidError: '¡Este cupón no puede ser aplicado a su pedido!',
        vouchers: 'Descuentos',
        yes: 'Sí',
        You: 'Usted',
        yourself: 'Usted',

    },
};
